<template>
  <div class="card">
    <span v-if="soldOut" class="badge badge-danger soldOutBadge text-uppercase"
      >Sold Out</span
    >
    <router-link
      :to="redirectToPurchase"
      class="stretched-link"
      style="text-decoration: none"
    >
      <b-skeleton-img v-if="loading" no-aspect height="320px"></b-skeleton-img>
      <b-img-lazy v-else class="card-img-top image" :src="packageImage" />

      <div class="card-body">
        <h6 class="card-title d-flex">
          <div class="flex-grow-1">
            <span v-if="requiresApplication && !loading">
              <ion-icon
                v-if="hasPurchaseRight"
                class="ion-icon-btn-align mr-1"
                style="color: black"
                name="lock-open"
              ></ion-icon>
              <ion-icon
                v-else
                class="ion-icon-btn-align mr-1"
                style="color: black"
                name="lock-closed"
              ></ion-icon>
            </span>

            <b-skeleton v-if="loading" width="70%"></b-skeleton>
            <span v-else style="color: black">{{ $filters.name(catalogPackage) }}</span>
          </div>
          <div v-if="!loading" class="ml-2">
            <span v-if="strikeThrough" class="d-block">
              <div class="line-through mr-1 text-muted">{{ cost }}</div>
              <div class="text-danger">{{ formatMoney(strikeThrough)}}</div>
            </span>
            <span v-else class="text-danger">{{ cost }}</span>
          </div>
        </h6>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getNoImageURL, isSectionSoldOut } from "../helpers/utils";
import { isSoldOut as isPackageSoldOut } from "../helpers/packages";
import { hasPurchaseRight } from "../helpers/entitlements";

export default {
  name: "CatalogCard",
  props: {
    catalogPackage: Object,
    loading: Boolean,
    section: Object,
    currency: String
  },
  methods: {
    formatMoney(amount) {
      return paidutils.formatMoney(amount, this.currency)
    }
  },
  computed: {
    redirectToPurchase() {
      const url = `/p/${this.catalogPackage?.id}`;
      if (Parse.User.current()) {
        return url;
      } else {
        return `/signin?redirect=${url}`;
      }
    },
    ...mapGetters("entitlements", ["paymentEntitlements"]),
    hasPurchaseRight() {
      return hasPurchaseRight(this.catalogPackage, this.paymentEntitlements);
    },
    soldOut() {
      return isSectionSoldOut(this.section) || isPackageSoldOut(this.catalogPackage);
    },
    requiresApplication() {
      return this.catalogPackage ? this.catalogPackage.get("useApplication") : false;
    },
    packageImage() {
      let thumbnail = getNoImageURL();

      // get most appropriate size of image
      if (this.catalogPackage.get("thumbnail_small")) {
        thumbnail = this.catalogPackage.get("thumbnail_small")._url;
      } else if (this.catalogPackage.get("thumbnail")) {
        thumbnail = this.catalogPackage.get("thumbnail")._url;
      }

      return thumbnail;
    },
    truncatedDescription() {
      const ending = "...";
      const length = 128;
      let desc = this.catalogPackage.get("desc");
      if (desc && desc.length > length) {
        desc = desc.substring(0, length - ending.length) + ending;
      }

      return desc;
    },
    strikeThrough() {
      return !_.isNull(this.catalogPackage.get("strikeThroughPrice"))
        ? this.catalogPackage.get("strikeThroughPrice")
        : null;
    },
    cost() {
      let costString = this.catalogPackage.get("showFreeText") ?? true ? "Free" : "";
      if (this.catalogPackage.get("cost") > 0) {
        costString = this.formatMoney(this.catalogPackage.get("cost"), this.currency)
      }
      return costString;
    },
  },
};
</script>

<style scoped>
.image {
  height: 320px;
  object-fit: cover;
  cursor: pointer;
}

.card {
  cursor: pointer;
}

.card-footer {
  border-top: none;
}

.card button {
  position: relative;
  top: -2px;
}

.card-title {
  font-weight: 400;
}

.soldOutBadge {
  position: absolute;
  top: 10px;
  right: 10px;
  border: 1px solid white;
}

@media (max-width: 1200px) {
  .image {
    height: 360px;
  }
}

@media (max-width: 768px) {
  .card {
    font-size: 70%;
  }

  .card-title {
    font-size: 100%;
  }

  .card button {
    font-size: 100%;
  }
}

.line-through {
  text-decoration: line-through;
}
</style>
